import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosInstance } from "axios";
import { useApi } from "@platform/api";

type MarketingPresentation = {
  id: number;
  rfpId: number;
  name: string;
  templateFolder: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
};

type PresentationData = {
  marketingPresentation: MarketingPresentation;
  marketingPresentationDocsFolderUrl: string;
};

const fetchMarketingPresentation = async (
  axiosInstance: AxiosInstance,
  rfpId: string | number,
  brokerExternalId: string,
): Promise<PresentationData> => {
  const result = await axiosInstance.get<PresentationData>(
    `/brokerportal/v1/rfp/${rfpId}/marketing-presentation?brokerId=${brokerExternalId}`,
  );
  return result.data;
};

const useMarketingPresentation = (
  rfpId: string | number,
  brokerExternalId: string,
): UseQueryResult<PresentationData, Error> => {
  const axiosInstance = useApi();
  return useQuery<PresentationData, Error>({
    queryKey: ["marketing-presentation", rfpId, brokerExternalId],
    queryFn: () =>
      fetchMarketingPresentation(axiosInstance, rfpId, brokerExternalId),
  });
};

export default useMarketingPresentation;
